import { computed, ref, watch, type Ref } from 'vue';
import type { TrainingCollaboratorListItem } from '@/entities/Training';
import { fetchAllTrainingCollaborators } from '../lib/fetchAllTrainingCollaborators';

const ERROR_MESSAGE = 'Não foi possível carregar os colaboradores. Tente novamente.';

export function useTrainingControlCollaborators(trainingId: Ref<number | null>) {
  const collaborators = ref<TrainingCollaboratorListItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  let currentQueryId = 0;

  async function fetch() {
    const id = trainingId.value;
    if (id === null) {
      collaborators.value = [];
      error.value = null;
      return;
    }

    const queryId = ++currentQueryId;
    loading.value = true;
    error.value = null;

    try {
      const result = await fetchAllTrainingCollaborators(id);
      if (queryId !== currentQueryId) return;
      collaborators.value = result;
    } catch {
      if (queryId !== currentQueryId) return;
      collaborators.value = [];
      error.value = ERROR_MESSAGE;
    } finally {
      if (queryId === currentQueryId) {
        loading.value = false;
      }
    }
  }

  watch(trainingId, () => void fetch(), { immediate: true });

  return {
    collaborators,
    loading,
    error,
    count: computed(() => collaborators.value.length),
  };
}
